export default "__VITE_ASSET__BSIgky8i__"